// Containers
import GameCardContainer from "containers/molecules/GameCardContainer";

// Types
import { GameType } from "types/Games";

import "./styles.sass";

type FavoriteGameListProps = {
  list: GameType[] | undefined;
};

const FavoriteGameList = (props: FavoriteGameListProps) => {
  const { list } = props;

  return (
    <div className="FavoriteGameList">
      <div className="FavoriteGameList__list">
        {list
          ? list.map((game) => (
              <GameCardContainer key={game.uuid + game.uuid} game={game} />
            ))
          : ""}
      </div>
    </div>
  );
};

export default FavoriteGameList;
